// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book {
  color: #AAA;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.spand {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
}
.card1 {
  padding: 8px;
  width: 78px;
  height: 40px;
  border-radius: 6px;
  line-height: 0.67;
  background-color: #f0f4f5;
}
.span1 {
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.67;
  letter-spacing: normal;
  text-align: center;
  color: #b2bac5;
}
.spn2 {
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #548dff;
}
.span2 {
  width: 106px;
  height: 28px;
  /* margin: 0 0 16px; */
  /* font-family: Poppins; */
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.58;
  letter-spacing: normal;
  text-align: center;
  color: var(--white);
}
.spn1 {
  margin: 4px 0 0;
  font-family: 'Roboto', sans-serif;
  /* font-family: Poppins; */
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.88;
  letter-spacing: normal;
  text-align: center;
  color: #b2bac5;
}

.card2 {
  width: 120px;
  height: 40px;
  margin: 0 5px;
  padding: 4px 12px 3px;
  border-radius: 6px;
  background-color: #548dff;
}
.slide {
  width: 100%;
  margin-right: 10px;
}
.card3 {
  width: 70px;
  height: 40px;
  margin: 0 5px;
  padding: 2.6px 10px 6px;
  opacity: 0.2;
  border-radius: 6px;
  background-color: white;
}
.span4 {
  width: 50px;
  height: 17px;
  margin: 0 0 3.4px;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.67;
  letter-spacing: normal;
  text-align: center;
  color: #548dff;
}

.card3 {
  width: 59px;
  height: 40px;
  margin: 0 5px;
  opacity: 0.2;
  border-radius: 6px;
  background-color: #548dff;
}
.span5 {
  width: 52px;
  height: 41px;
  margin: 0px 0 0 5px;
  opacity: 0.2;
  border-radius: 6px;
  background-color: black;
}
.btnbutton {
  width: 16px;
  height: 16px;
  margin: 14px;
}
.htag {
  color: #DB0406;
font-family: Roboto;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
}
.sub {
  color: #000;
font-family: Roboto;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
}
.card9 {
  width: 70px;
  height: 40px;
  margin: 0 5px;
  padding: 2.6px 10px 6px;
  opacity: 0.2;
  border-radius: 6px;
  background-color: #548dff;
}
.slider-container {
    display: flex;
    justify-content: center;
  }
  .slide {
    width: 100%;
  }
  
  .slide.active {
    width: 80%;
  }
  
  @media (max-width: 768px) {
    .slider-container {
      flex-direction: column;
      align-items: center;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Calendar/scheduler/bookingDetails/bookingdetail.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB,mBAAmB;AACnB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;EACE,WAAW;AACb,mBAAmB;AACnB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;IACI,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,sBAAsB;MACtB,mBAAmB;IACrB;EACF","sourcesContent":[".book {\n  color: #AAA;\n  font-family: Roboto;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.spand {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000;\n}\n.card1 {\n  padding: 8px;\n  width: 78px;\n  height: 40px;\n  border-radius: 6px;\n  line-height: 0.67;\n  background-color: #f0f4f5;\n}\n.span1 {\n  font-size: 15px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 0.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: #b2bac5;\n}\n.spn2 {\n  font-size: 10px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: #548dff;\n}\n.span2 {\n  width: 106px;\n  height: 28px;\n  /* margin: 0 0 16px; */\n  /* font-family: Poppins; */\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.58;\n  letter-spacing: normal;\n  text-align: center;\n  color: var(--white);\n}\n.spn1 {\n  margin: 4px 0 0;\n  font-family: 'Roboto', sans-serif;\n  /* font-family: Poppins; */\n  font-size: 10px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 0.88;\n  letter-spacing: normal;\n  text-align: center;\n  color: #b2bac5;\n}\n\n.card2 {\n  width: 120px;\n  height: 40px;\n  margin: 0 5px;\n  padding: 4px 12px 3px;\n  border-radius: 6px;\n  background-color: #548dff;\n}\n.slide {\n  width: 100%;\n  margin-right: 10px;\n}\n.card3 {\n  width: 70px;\n  height: 40px;\n  margin: 0 5px;\n  padding: 2.6px 10px 6px;\n  opacity: 0.2;\n  border-radius: 6px;\n  background-color: white;\n}\n.span4 {\n  width: 50px;\n  height: 17px;\n  margin: 0 0 3.4px;\n  font-size: 13px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 0.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: #548dff;\n}\n\n.card3 {\n  width: 59px;\n  height: 40px;\n  margin: 0 5px;\n  opacity: 0.2;\n  border-radius: 6px;\n  background-color: #548dff;\n}\n.span5 {\n  width: 52px;\n  height: 41px;\n  margin: 0px 0 0 5px;\n  opacity: 0.2;\n  border-radius: 6px;\n  background-color: black;\n}\n.btnbutton {\n  width: 16px;\n  height: 16px;\n  margin: 14px;\n}\n.htag {\n  color: #DB0406;\nfont-family: Roboto;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n.sub {\n  color: #000;\nfont-family: Roboto;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n.card9 {\n  width: 70px;\n  height: 40px;\n  margin: 0 5px;\n  padding: 2.6px 10px 6px;\n  opacity: 0.2;\n  border-radius: 6px;\n  background-color: #548dff;\n}\n.slider-container {\n    display: flex;\n    justify-content: center;\n  }\n  .slide {\n    width: 100%;\n  }\n  \n  .slide.active {\n    width: 80%;\n  }\n  \n  @media (max-width: 768px) {\n    .slider-container {\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
